<template>
  <div class="windows zeromp">
    <div class="mycontainer zeromp">
      <div class="tile parent-contanier zeromp">
        <div class="tile is-ancestor box is-2 zeromp">
          <sidebar :cargo="cargo" />
        </div>

        <div class="tile is-ancestor is-vertical box is-12 zeromp">
          <div class="tile is-parent is-12 zeromp">
            <article class="tile is-child zeromp">
              <div class="content zeromp">
                <internnavbar />
              </div>
            </article>
          </div>
          <div class="tile is-vertical is-12 internbackground">
            <div class="tile is-parent is-vertical">
              <div class="tile is-child">
                <p class="indextitle">
                {{cargo == 'corretor' ? 'Minhas Correções' : 
                 (cargo == 'aluno'    ? 'Minhas Redações'  : 'Redações') }}
                </p>
                <b-button @click="showFiltersBar" class="lupabusca">
                  <i class="fas fa-search dp-none"></i>
                </b-button>
                <b-button @click="hideFiltersBar" class="lupabusca closeLupa">
                  <i class="fas fa-times dp-none"></i>
                </b-button>

                <!--Adicionar Redação (Aluno)-->
                <div v-if="cargo == 'aluno'" class="block dp-none">
                  <router-link :to="{ name: 'redacao/create'}">
                    <b-button
                      class="button form-submit rigth custom-top"
                      type="is-link"
                    >ADICIONAR NOVA REDAÇÃO</b-button>
                  </router-link>
                </div>

                <!--<button v-on:click="configSearchCorrigidas">teste</button>-->

                <div>
                  <div id="tabela-correcaos">

                    <b-tabs style="margin-left:3.5%;margin-right:3.5%;">
                      
                      <!--########################-->
                      <!-- A CORRIGIR             -->
                      <!--########################-->

                      <b-tab-item class="tab-c" label="A Corrigir">
                        <b-table
                          :data="isEmpty ? [] : redacaos.aCorrigir.data"
                          paginated
                          backend-pagination
                          @page-change="searchACorrigir"
                          :total="redacaos.aCorrigir.total"
                          :per-page="redacaos.aCorrigir.per_page"
                          :hoverable="true"
                          >
                          <template slot-scope="props">
                            <input type="hidden" :id="props.row.id"/>
                            
                            <!-- ENVIADA EM (all) -->
                            <b-table-column
                              field="created_at"
                              label="Enviada em"
                              searchable
                            >{{ props.row.created_at }}
                              <!-- FEEDBACK -->
                              <b-tooltip
                                class="is-warning tooltipN"
                                v-if="props.row.feedback != null"
                                :label="props.row.feedback"
                                multilined
                              >
                                <b-button size="is-small" class="button is-warning tooltipB" icon-left="alert" @click="redacaoInfo(props.row.id), isCardModalActive = true"></b-button>
                              </b-tooltip>

                              <!-- CORRIGINDO -->
                              <b-tooltip
                                class="is-success tooltipN"
                                v-if="props.row.corrigindo != null && cargo == 'admin'"
                                :label="props.row.corrigindo"
                                multilined
                              >
                                <b-button size="is-small" class="button is-light tooltipB" icon-left="pencil" @click="liberar(props.row.id)"></b-button>
                              </b-tooltip>
                            </b-table-column>

                            <!-- NUMERO (Admin, Diretor, Corretor, Professor) -->
                            <b-table-column v-if="cargo != 'aluno'"
                              field="numero"
                              label="N° Redação"
                              searchable
                            >{{ props.row.numero }}</b-table-column>

                            <!-- ALUNO NOME (Admin, Diretor, Corretor, Professor) -->
                            <b-table-column v-if="cargo != 'aluno'"
                              field="aluno.name"
                              label="Nome"
                              searchable
                            >{{ props.row.aluno.name }}</b-table-column>

                            <!-- ALUNO SOBRENOME (Admin, Diretor, Corretor, Professor) -->
                            <b-table-column v-if="cargo != 'aluno'"
                              field="aluno.sobrenome"
                              label="Sobrenome"
                              searchable
                            >{{ props.row.aluno.sobrenome }}</b-table-column>
                            
                            <!-- PROPOSTA (all) -->
                            <b-table-column
                              field="proposta"
                              label="Proposta"
                              searchable
                            >{{ props.row.proposta }}</b-table-column>

                            <!-- GRADE (all) -->
                            <b-table-column
                              field="grade"
                              label="Grade"
                              searchable
                            >{{ props.row.grade }}</b-table-column>

                            <!-- ESCOLA (Admin, Diretor, Corretor, Professor) -->
                            <b-table-column v-if="cargo != 'aluno'"
                              field="escola"
                              label="Escola"
                              searchable
                            >{{ props.row.escola }}</b-table-column>

                            <b-table-column field="actions" class="actionsHover" centered>
                              
                              <!-- DETALHES (all) -->
                              <b-tooltip label="Detalhes" position="is-top" type="is-dark">
                                <button
                                  class="button is-primary is-round"
                                  id="info"
                                  @click="redacaoInfo(props.row.id), isCardModalActive = true"
                                >
                                  <b-icon icon="eye"></b-icon>
                                </button>
                              </b-tooltip>

                              <!-- EDITAR REDAÇÃO (Aluno) -->
                              <b-tooltip v-if="cargo == 'aluno'" label="Editar" position="is-top" type="is-dark">
                                <router-link
                                  :to="{ name: 'redacao/update', params: { uuid: props.row.id }}"
                                >
                                  <button class="button is-primary is-round" id="edit">
                                    <b-icon icon="pencil"></b-icon>
                                  </button>
                                </router-link>
                              </b-tooltip>

                              <!-- CORRIGIR (Corretor) -->
                                <b-tooltip v-if="cargo == 'corretor'" label="Corrigir" position="is-top" type="is-dark">
                                  <router-link
                                    :to="{ name: 'redacao/corrigir', params: { uuid: props.row.id }}"
                                    target="_blank"
                                  >
                                    <button class="button is-primary is-round" id="edit">
                                      <b-icon icon="pencil"></b-icon>
                                    </button>
                                  </router-link>
                                </b-tooltip>

                              <!-- DELETAR REDAÇÃO (Admin, Aluno) -->
                              <b-tooltip v-if="cargo == 'admin' || cargo == 'aluno'" label="Deletar" position="is-top" type="is-dark">
                                <button
                                  class="button is-primary is-round"
                                  id="delete"
                                  @click="deletarRedacao(props.row.id)"
                                >
                                  <b-icon icon="delete-outline"></b-icon>
                                </button>
                              </b-tooltip>
                            </b-table-column>
                          </template>
                          <template slot="empty">
                            <Empty :messageEmpty="'Nada aqui.'" />
                          </template>
                          <template slot="loading">
                            <Empty :messageEmpty="'Carregando...'" />
                          </template>
                        </b-table>
                      </b-tab-item>

                      <!--########################-->
                      <!-- CORRIGIDAS             -->
                      <!--########################-->

                      <b-tab-item class="tab-c" label="Corrigidas">
                        <b-table
                          :data="isEmpty ? [] : redacaos.corrigidas.data"
                          paginated
                          backend-pagination
                          @page-change="searchCorrigidas"
                          :total="redacaos.corrigidas.total"
                          :per-page="redacaos.corrigidas.per_page"
                          :hoverable="true"
                        >
                          <template slot-scope="props">
                            
                            <!-- CORRIGIDA EM (all) -->
                            <input type="hidden" :id="props.row.id"/>
                            <b-table-column
                              field="created_at"
                              label="Corrigida em"
                              searchable
                            >{{ props.row.created_at }}</b-table-column>

                            <!-- CORRETOR (Admin, Aluno, Diretor, Professor) -->
                            <b-table-column v-if="cargo != 'corretor'"
                              field="corretor.name"
                              label="Corretor"
                              searchable
                            >{{ props.row.corretor.name }}</b-table-column>

                            <!-- NUMERO (Admin, Corretor, Diretor, Professor) -->
                            <b-table-column v-if="cargo != 'aluno'"
                              field="redacao.numero"
                              label="N° Redação"
                              searchable
                            >{{ props.row.redacao.numero }}</b-table-column>

                            <!-- ALUNO NOME (Admin, Corretor, Diretor, Professor) -->
                            <b-table-column v-if="cargo != 'aluno'"
                              field="redacao.aluno.name"
                              label="Nome"
                              searchable
                            >{{ props.row.redacao.aluno.name }}</b-table-column>

                            <!-- ALUNO SOBRENOME (Admin, Corretor, Diretor, Professor) -->
                            <b-table-column v-if="cargo != 'aluno'"
                              field="redacao.aluno.sobrenome"
                              label="Sobrenome"
                              searchable
                            >{{ props.row.redacao.aluno.sobrenome }}</b-table-column>

                            <!-- PROPOSTA (all) -->
                            <b-table-column
                              field="proposta"
                              label="Proposta"
                              searchable
                            >{{ props.row.proposta }}</b-table-column>

                            <!-- GRADE (all) -->
                            <b-table-column
                              field="grade"
                              label="Grade"
                              searchable
                            >{{ props.row.grade }}</b-table-column>

                            <!-- ESCOLA (Admin, Corretor, Diretor, Professor) -->
                            <b-table-column v-if="cargo != 'aluno'"
                              field="redacao.escola"
                              label="Escola"
                              searchable
                            >{{ props.row.redacao.escola }}</b-table-column>

                            <!-- NOTA FINAL (all) -->
                            <b-table-column label="Nota Final">{{ props.row.nota_final }}</b-table-column>

                            <b-table-column field="actions" class="actionsHover" centered>
                              
                              <!-- DETALHES (all) -->
                              <b-tooltip label="Detalhes" position="is-top" type="is-dark">
                                <button
                                  class="button is-primary is-round"
                                  id="info"
                                  @click="correcaoInfo(props.row.id), isCardModalActive2 = true"
                                >
                                  <b-icon icon="eye"></b-icon>
                                </button>
                              </b-tooltip>

                              <!-- DELETAR CORREÇÃO (Admin) -->
                              <b-tooltip v-if="cargo == 'admin'" label="Deletar" position="is-top" type="is-dark">
                                <button
                                  class="button is-primary is-round"
                                  id="delete"
                                  @click="deletarCorrecao(props.row.id)"
                                >
                                  <b-icon icon="delete-outline"></b-icon>
                                </button>
                              </b-tooltip>
                            </b-table-column>
                          </template>
                          <template slot="empty">
                            <Empty :messageEmpty="'Nada aqui.'" />
                          </template>
                          <template slot="loading">
                            <Empty :messageEmpty="'Carregando...'" />
                          </template>
                        </b-table>
                      </b-tab-item>
                    </b-tabs>
                  </div>
                </div>

                <b-modal :active.sync="isCardModalActive">
                  <div class="card">
                    <div class="card-content">
                      <div class="content">
                        <img :src="redacao.url" alt="redaçao" />
                        <ul>
                          <li>
                            Enviada:
                            <span class="profile-infos-span">{{ redacao.created_at }}</span>
                          </li>
                          <li class="separador"></li>
                          <li>
                            N° Redação:
                            <span class="profile-infos-span">{{ redacao.numero }}</span>
                          </li>
                          <li class="separador"></li>
                          <li>
                            Aluno:
                            <span class="profile-infos-span">{{ redacao.aluno.name + " " + redacao.aluno.sobrenome }}</span>
                          </li>
                          <li class="separador"></li>
                          <li>
                            Proposta:
                            <a :url="redacao.proposta_url">{{ redacao.proposta }}</a>
                          </li>
                          <li class="separador"></li>
                          <li>
                            Grade:
                            <span class="profile-infos-span">{{ redacao.grade }}</span>
                          </li>
                          <li class="separador"></li>
                          <li>
                            Escola:
                            <span class="profile-infos-span">{{ redacao.escola }}</span>
                          </li>
                          <li class="separador"></li>
                          <li v-if="redacao.feedback">
                            <div>
                              <b-notification
                                class="updateFormFeed"
                                v-if="redacao.feedback != null"
                                type="is-warning"
                                has-icon
                                aria-close-label="Close notification"
                                role="alert"
                              >
                                <strong>Feedback:</strong>
                                {{redacao.feedback}}
                              </b-notification>
                            </div>
                          </li>
                        </ul>
                        
                      </div>
                    </div>
                  </div>
                </b-modal>
                <b-modal :active.sync="isCardModalActive2">
                  <div class="card">
                    <div class="card-content">
                      <div class="content d-card2">
                        <iframe
                          allowfullscreen
                          v-bind:src=" 'https://player.vimeo.com/video/'  + correcao.video "
                        ></iframe>

                        <div class="columns is-multiline" style="margin-top: 30px;">
                          <div class="column is-half">
                            <b-field label="Corrigida em">{{ correcao.created_at }}</b-field>
                          </div>
                          <div class="column is-half">
                            <b-field label="N° Redação">{{ correcao.redacao.numero }}</b-field>
                          </div>
                          <div class="column is-half">
                            <b-field
                              label="Nome Completo - (Aluno)"
                            >{{ correcao.redacao.aluno.name + " " + correcao.redacao.aluno.sobrenome}}</b-field>
                          </div>
                          <div class="column is-half">
                            <b-field label="Proposta">{{ correcao.proposta }}</b-field>
                          </div>
                          <div class="column is-half">
                            <b-field label="Grade">{{ correcao.grade }}</b-field>
                          </div>
                          <div class="column is-half">
                            <b-field label="Escola">{{ correcao.redacao.escola }}</b-field>
                          </div>
                          <div class="column is-full">
                            <b-field
                              label="Comentário"
                              style="text-align:justify;"
                            >{{ correcao.comentario }}</b-field>
                          </div>
                        </div>
                        <table>
                          <tr>
                            <th>Critérios</th>
                            <th>Descrição</th>
                            <th>Notas</th>
                          </tr>
                          <tr v-for="nota in correcao.notas" :key="nota.id">
                            <td>{{ nota.criterio.nome }}</td>
                            <td>{{ nota.criterio.descricao }}</td>
                            <td>{{ nota.valor }}</td>
                          </tr>
                          <tr>
                            <th>Nota Final</th>
                            <td></td>
                            <td>{{ correcao.nota_final }}</td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>
                </b-modal>
              </div>
              <internfooter />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint no-console: ["error", { allow: ["warn", "error", "log", "info"] }] */
import RedacaoService from "@/services/RedacaoService";
import CorrecaoService from "@/services/CorrecaoService";
import internnavbar from "@/components/Navbars/InternNav";
import internfooter from "@/components/Footers/InternFooter";
import sidebar from "@/components/SideBar/SideBar";
import Empty from "@/components/Tables/Empty";
import store from "@/store";

export default {
  data() {
    return {
      redacaos: {
        aCorrigir: {},
        corrigidas: {},
      },
      dateSearch: "",
      loading: true,
      redacao: {
        aluno: []
      },
      correcao: {
        redacao: {
          aluno: []
        },
        notas: {}
      },
      isEmpty: false,
      isImageModalActive: false,
      isCardModalActive: false,
      isCardModalActive2: false,
      cargo: store.getters.cargo,
      cargoId: store.getters.cargo_id,
      loadedCorrigidas: false
    };
  },
  components: {
    internnavbar: internnavbar,
    internfooter: internfooter,
    sidebar: sidebar,
    Empty: Empty
  },
  created() {
    this.loading = true;

    // A CORRIGIR
    RedacaoService.Index(this.cargo, this.cargoId, 1, false).then(result => {
      result.data = Object.values(result.data)
      this.redacaos.aCorrigir = result;
    });

    // CORRIGIDAS
    RedacaoService.Index(this.cargo, this.cargoId, 1, true).then(result => {
      result.data = Object.values(result.data)
      this.redacaos.corrigidas = result;
    });

  },

  updated(){
    if(this.loading){
      this.configSearchACorrigir();
      document.getElementsByClassName("tabs")[0].onclick = this.configSearchCorrigidas;
      this.loading = false;
    }
  },

  methods: {
    // A CORRIGIR
    onPageChangeACorrigir(page, created_at, numero, nome, sobrenome, proposta, grade, escola) {
      RedacaoService.Index(this.cargo, this.cargoId, page, false,
      created_at, '', numero, nome, sobrenome, proposta, grade, escola).then(result => {
        result.data = Object.values(result.data)
        this.redacaos.aCorrigir = result;
        //console.log(this.redacaos);
      });
    },
    configSearchACorrigir(){

      this.tableOverrideInputs(
        document.getElementsByClassName("table")[0],
        this.searchACorrigir,
        this.cargo == 'aluno' ? [0, 1, 2] : [0, 1, 2, 3, 4, 5, 6]
      );
    },
    searchACorrigir(page){
      page = page == undefined ? 1 : page;
      let p = document.getElementsByClassName("table")[0].firstElementChild.lastElementChild.getElementsByTagName('input');
      if(this.cargo == 'aluno'){
        this.onPageChangeACorrigir(page, p[0].value, '', '', '', p[1].value, p[2].value, '');
      }else{
        this.onPageChangeACorrigir(page, p[0].value, p[1].value, p[2].value, 
        p[3].value, p[4].value, p[5].value, p[6].value);
      }
    },
    // CORRIGIDAS
    onPageChangeCorrigidas(page, created_at, corretor, numero, nome, sobrenome, proposta, grade, escola) {
      RedacaoService.Index(this.cargo, this.cargoId, page, true,
      created_at, corretor, numero, nome, sobrenome, proposta, grade, escola).then(result => {
        result.data = Object.values(result.data)
        this.redacaos.corrigidas = result;
        //console.log(this.redacaos);
      });
    },
    configSearchCorrigidas(){
      if(!this.loadedCorrigidas){
        //alert();
        this.tableOverrideInputs(
          document.getElementsByClassName("table")[1],
          this.searchCorrigidas,
          this.cargo == 'aluno' ? [0, 1, 2, 3] : 
          ( this.cargo == 'corretor' ? [0, 1, 2, 3, 4, 5, 6] 
          : [0, 1, 2, 3, 4, 5, 6, 7] )
        );
        this.loadedCorrigidas = true;
      }
    },
    searchCorrigidas(page){
      page = page == undefined ? 1 : page;
      let p = document.getElementsByClassName("table")[1].firstElementChild.lastElementChild.getElementsByTagName('input');
      if(this.cargo == 'aluno'){
        this.onPageChangeCorrigidas(page, p[0].value, p[1].value, '', '', '', p[2].value, p[3].value, '');
      } else 
      if(this.cargo == 'corretor'){
        this.onPageChangeCorrigidas(page, p[0].value, '', p[1].value, p[2].value, 
        p[3].value, p[4].value, p[5].value, p[6].value);
      }
      else{
        this.onPageChangeCorrigidas(page, p[0].value, p[1].value, p[2].value, 
        p[3].value, p[4].value, p[5].value, p[6].value, p[7].value);
      }
    },
    //\\
    deletarRedacao(uuid) {
      this.serviceDelete(
        "Você tem certeza que deseja deletar essa redação?", 
        "Redação deletada com sucesso", 
        RedacaoService.Delete, 
        uuid,
        this.$buefy.toast,
        document.getElementById(uuid).parentNode
      );
    },
    deletarCorrecao(uuid) {
      this.serviceDelete(
        "Você tem certeza que deseja deletar essa correção?", 
        "Correção deletada com sucesso", 
        CorrecaoService.Delete, 
        uuid,
        this.$buefy.toast,
        document.getElementById(uuid).parentNode
      );
    },
    redacaoInfo(id) {
      RedacaoService.Info(id).then(result => {
        this.redacao = result.data;
      });
    },
    correcaoInfo(id) {
      CorrecaoService.Info(id).then(result => {
        this.correcao = result.data;
      });
    },
    liberar(id){
      if(confirm("Deseja liberar essa redação de volta para a fila?")){
        RedacaoService.LiberarCorrecao(id).then(() => {
          this.$buefy.toast.open({
            duration: 5000,
            message: "Redação liberada", // Message on successfully delete
            position: "is-top-right",
            type: "is-success"
          }); // buefy toast
        });
        document.getElementById(id).nextSibling.lastChild.remove();
      }
    }
  }
};
</script>
<style scoped>
.modal.is-active >>> .animation-content {
  /*max-width: none !important;*/
  width: 80%;
}
.card {
  border-radius: 40px 0 0 40px;
}
.card > .card-content > .content > img {
  width: 73.5%;
}
.card > .card-content > .content > ul > li > a {
  float: right;
}
.d-card2 {
  display: inline-block !important;
}
@media only screen and (max-width: 720px) {
  .mycontainer.zeromp {
    margin-left: 20px !important;
    margin-top: -50px !important;
  }
}
</style>
<style scoped>
iframe {
  width: 1920px;
  height: 1080px;
  margin-top: -30%;
  margin-bottom: -32%;
}

.card > .card-content > .content {
  display: inline-flex;
}

.field:not(:last-child) {
  margin-right: 15%;
  white-space: nowrap;
}

tr:hover .actionsHover {
  width: 153.75px !important;
}

</style>